export const InputOptions = {
  fullWidth: true,
};

export const DisabledSelectOptions = {
  ...InputOptions,
  disabled: true,
  inputStyle: {
    color: 'black'
  },
  labelStyle: {
    color: 'black'
  },
};

export const DisabledInputOptions = {
  ...InputOptions,
  disabled: true,
  inputStyle: {
    color: 'black'
  },
};

export const COUNTRY_TH = 'th';
export const COUNTRY_VN = 'vn';
export const COUNTRY_ID = 'id';

export const RECORD_FORM = 'record-form';
export const FILTER_FORM = 'filter-form';

export const getActiveLanguage = () => {
  const active_country = process.env.REACT_APP_COUNTRY.trim();
  if (active_country === COUNTRY_VN) {
    return 'vi';
  }

  return active_country;
};



// WEBPACK FOOTER //
// ./src/util/constants.js